'use client';
import React from 'react';
import Link from 'next/link';
import { Home, Search, Calendar, User, MessageCircle } from 'lucide-react';
import { usePathname } from 'next/navigation';

const navItems = [
  { icon: Home, label: 'Home', href: '/home-screen' },
  { icon: Search, label: 'Explore', href: '/rituals' },
  { icon: Calendar, label: 'Book', href: '/booking-flow' },
  { icon: MessageCircle, label: 'AI Guide', href: '/ai-guide' },
  { icon: User, label: 'Profile', href: '/dashboard' },
];

export default function HomeBottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/98 backdrop-blur-xl border-t border-gold/20 safe-area-pb"
      role="navigation"
      aria-label="Bottom navigation"
    >
      <div className="flex items-center justify-around px-1 pt-1.5 pb-1">
        {navItems?.map((item) => {
          const isActive = pathname === item?.href || pathname?.startsWith(item?.href + '/');
          return (
            <Link
              key={item?.label}
              href={item?.href}
              aria-label={item?.label}
              aria-current={isActive ? 'page' : undefined}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-200 min-w-[56px] ${
                isActive ? 'text-saffron' : 'text-maroon/40 hover:text-maroon/70'
              }`}
            >
              <div className={`relative transition-all duration-200 ${isActive ? 'scale-110' : ''}`}>
                <item.icon
                  size={22}
                  strokeWidth={isActive ? 2.5 : 1.8}
                  aria-hidden="true"
                />
                {isActive && (
                  <div className="absolute -inset-1 rounded-full bg-saffron/15 -z-10" aria-hidden="true" />
                )}
              </div>
              <span className={`text-[10px] font-medium leading-none ${isActive ? 'text-saffron' : 'text-maroon/40'}`}>
                {item?.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}